import { Box, Divider, Link } from '@mui/material';
import { FC } from 'react';

import { QuestionMarkIcon } from '@abg/kit-base';
import {
  StyledOptionContainer,
  StyledOptionIcon,
  StyledOptionText,
} from '@abg/kit-base/lib/atoms/AutocompleteOption.styled';

import { iconStyle } from '../../atoms/location-icon/location-icon.styling';

import {
  BROWSE_LOCATION,
  KEEP_TYPING,
  NO_MATCH_FOUND,
  REVISE_SEARCH,
} from './no-matches-card.constants';
import {
  additionalTextStyles,
  containerStyles,
} from './no-matches-card.styling';

interface NoMatchesCardProperties {
  title: string;
  subTitle?: string;
  linkText?: string;
  link?: string;
  additionalText?: string;
}

const NoMatchesOption: FC<NoMatchesCardProperties> = ({
  title = NO_MATCH_FOUND,
  subTitle = REVISE_SEARCH,
  linkText = BROWSE_LOCATION,
  link = '#',
  additionalText = KEEP_TYPING,
}) => {
  return (
    <Box sx={containerStyles}>
      <StyledOptionContainer>
        <StyledOptionIcon>
          {<QuestionMarkIcon sx={iconStyle} />}
        </StyledOptionIcon>
        <StyledOptionText>
          <h3 data-testid={'no-match-error-option-title'}>{title}</h3>
          {subTitle && (
            <p data-testid={'no-match-error-option-subtitle'}>
              {subTitle}
              {linkText && link && (
                <Link href={link} underline="hover">
                  {` ${linkText}`}
                </Link>
              )}
            </p>
          )}
        </StyledOptionText>
      </StyledOptionContainer>

      {additionalText && (
        <Box>
          <Divider sx={{ my: 1 }} />
          <StyledOptionText sx={additionalTextStyles}>
            <p data-testid={'no-match-error-option-additional-text'}>
              {additionalText}
            </p>
          </StyledOptionText>
        </Box>
      )}
    </Box>
  );
};

export default NoMatchesOption;
